import { DateTime } from 'luxon';

/**
 * 
 * @param {Json} json 
 * @param {String} locale 
 * @returns {Json}
 */
export default function replace(json, locale = null) {

    if (locale === null) {

        // TODO: What should the env variable be
        locale = (typeof process !== 'undefined' && process.env && process.env.LOCALE) ? process.env.LOCALE: 'sv-SE';
    }

    const dt = DateTime.now().setLocale(locale);
    const currentYear = dt.year;
    const currentMonth = dt.monthLong;

    replacePrismicObject(json, '%year%', currentYear);
    replacePrismicObject(json, '%month%', currentMonth);

    return JSON.parse(
        JSON.stringify(json)
            .replace(/%year%/g, currentYear)
            .replace(/%month%/g, currentMonth)
    );
}

/**
 * Function that helps with replacing serch with replace in prismic 
 * rich text objects, we need to fix the placement of spans depending on 
 * what we replace.
 * @param object Array, Object, or whatever
 * @param search string
 * @param replace string
 * @return nothing, the object is changed directly
 */
export function replacePrismicObject(objectOrArray, search, replace) {

    // typecast to Strings
    search = String(search); replace = String(replace);
    
    if (! objectOrArray) {
        return;
    }
    
    if (Array.isArray(objectOrArray)) {
        objectOrArray.forEach(o => {
            replacePrismicObject(o, search, replace);
        });
        return; 
    }

    if (typeof objectOrArray === 'object') {
        
        if (
            objectOrArray.type && 
            objectOrArray.text && 
            objectOrArray.spans
        ) {

            if (objectOrArray.spans.length === 0) {
                objectOrArray.text = objectOrArray.text.replace(new RegExp(search, 'g'), replace);
                return;
            }

            const indexes = findAllIndexesInString(objectOrArray.text, search);

            if (indexes.length > 0) {

                const lengthDifference = replace.length - search.length;
                objectOrArray.text = objectOrArray.text.replace(new RegExp(search, 'g'), replace);

                objectOrArray.spans.forEach(span => {
                    indexes.forEach(index => {
                        if (span.start > index) {
                            span.start += lengthDifference;
                            span.end += lengthDifference;
                        }
                        else if (span.end > index) {
                            span.end += lengthDifference;
                        }
                    });
                });
            }
        }
        else {
            Object.values(objectOrArray).forEach(r => {
                replacePrismicObject(r, search, replace);
            });
        }
    }
}

function findAllIndexesInString(string, search) {
    let index = string.indexOf(search);
    let indexes = [];
    let last;

    // eslint-disable-next-line no-constant-condition
    while (index >= 0) {
        last = index; 
        indexes.push(index);
        index = string.indexOf(search, last + 1);
    }

    return indexes;
}